import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://github.com/Andrew191103',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://www.instagram.com/andrew.sebastians/',
    label: 'Instagram',
    icon: faInstagram,
  },
  {
    link: 'https://id.linkedin.com/in/andrew-sebastian-sibuea-845905337',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'mailto:andrewsbastians11@gmail.com',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
